import { useClassStore } from '@Utils/useClassStore';
import { injectable } from 'inversify';
import { observable } from 'mobx';

import container from '~ioc/ioc';

@injectable()
export class HeroLoadingTracker {
  loaded = observable.map<string, boolean>({});
}

export const useHeroLoadingTracker = () =>
  useClassStore<HeroLoadingTracker>(container.get(HeroLoadingTracker));
